/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TargetsidTarget from './TargetsidTarget';

/**
 * The TargetsIdBody model module.
 * @module model/TargetsIdBody
 * @version v0.3
 */
export default class TargetsIdBody {
  /**
   * Constructs a new <code>TargetsIdBody</code>.
   * @alias module:model/TargetsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TargetsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TargetsIdBody} obj Optional instance to populate.
   * @return {module:model/TargetsIdBody} The populated <code>TargetsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TargetsIdBody();
      if (data.hasOwnProperty('target'))
        obj.target = TargetsidTarget.constructFromObject(data['target']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TargetsidTarget} target
 */
TargetsIdBody.prototype.target = undefined;

